import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Form, Field } from 'react-final-form';
import { Button, Modal } from 'react-bootstrap';
import {
  assetsLiabilitiesSelectOptions,
  industrySelectOptions,
  limitSelectOptions,
  scheduleCategorySelectOptions,
  scheduleSelectOptions,
} from '../formData';
import '../AdvancedSearch.less';

const ScheduleFilterModal = ({ onSave, show, onClose, filter }) => (
  <Modal show={show} onHide={onClose} dialogClassName="advanced-search-modal">
    <div>
      <Form
        onSubmit={onSave}
        initialValues={filter}
        render={({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Schedules Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="advanced-search-form">
                <div className="form-item form-item-row">
                  <Field name="schedule" parse={({ value }) => value}>
                    {({ input }) => (
                      <div className="col-2">
                        <label>Schedule</label>
                        <Select {...input} clearable={false} options={scheduleSelectOptions} className="form-select" />
                      </div>
                    )}
                  </Field>
                  <Field name="schedule_category" parse={({ value }) => value}>
                    {({ input }) => (
                      <div className="col-2">
                        <label>Category</label>
                        <Select
                          {...input}
                          clearable={false}
                          options={scheduleCategorySelectOptions}
                          className="form-select"
                          disabled={values.schedule !== 'schedule_ab'}
                        />
                      </div>
                    )}
                  </Field>
                </div>
                <div className="form-item form-item-row">
                  <div className="col-2">
                    <label>From</label>
                    <Field
                      name="schedule_value_from"
                      component="input"
                      type="text"
                      className="form-input"
                      placeholder="$"
                    />
                  </div>
                  <div className="col-2">
                    <label>To</label>
                    <Field
                      name="schedule_value_to"
                      component="input"
                      type="text"
                      className="form-input"
                      placeholder="$"
                    />
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={onClose}>Cancel</Button>
              <Button bsStyle="primary" type="submit">
                Apply
              </Button>
            </Modal.Footer>
          </form>
        )}
      />
    </div>
  </Modal>
);

ScheduleFilterModal.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  filter: PropTypes.object.isRequired,
};

ScheduleFilterModal.defaultProps = {
  show: false,
};

export default ScheduleFilterModal;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/resultForms/ScheduleFilterModal.jsx